// src/components/PrivateRoute.jsx
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, token } = useContext(AuthContext);

  // Not logged in
  if (!token || !user) return <Navigate to="/login" replace />;

  // Role not allowed
  if (!allowedRoles.includes(user.role)) return <Navigate to="/login" replace />;

  return children;
};

export default PrivateRoute;
